// const isLocal = window.location.hostname === "localhost";

// export const url = isLocal ? "https://dev.brightcity.in/server/brightcityServer.php" :"/server/brightcityServer.php";

const hostname = window.location.hostname;

const isCordova =
  typeof window !== "undefined" &&
  typeof window.cordova !== "undefined";

let apiUrl = "";
let modules = {};

if (isCordova) {
  // Android/iOS Cordova App
  apiUrl = "https://dev.brightcity.in/server/v22/brightcityServer.php";
} else if (hostname === "localhost" || hostname === "127.0.0.1") {  
  // React development
  apiUrl = "https://dev.brightcity.in/server/v22/brightcityServer.php";
} else if (hostname === "dev.brightcity.in") {
  // Web production
  apiUrl = "/server/v22/brightcityServer.php";
} else {
  apiUrl = "/server/brightcityServer.php";
}

export const url = apiUrl;

export const setModules = (data) => {
  modules = data;
};

export const getModules = () => {
  return modules;
};

export const verifyUserSession = async (authKey) => {
    try {
      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: "Bearer " + authKey,
        },
        body: new URLSearchParams({ workforce: "verifiedData" }),
      });

      const data = await res.json();

      if (data.Result === 1 && data.modules && Object.keys(data.modules).length > 0) {
        // localStorage.setItem("modules", JSON.stringify(data.modules));
        setModules(data.modules);
        
        localStorage.setItem("userInfo", JSON.stringify(data.data));
        // Keep a dedicated copy for components that read profileDetails directly
        localStorage.setItem("profileDetails", JSON.stringify(data.data));
        // Notify in-tab listeners that profileDetails/userInfo were updated
        try {
          window.dispatchEvent(new Event('profileDetailsUpdated'));
        } catch (e) {
          // ignore if dispatching fails
        }
        return { success: true, data };
      } else {
        return { success: false };
      }
    } catch (error) {
      console.error("Verify session error:", error);
      return { success: false };
    }
};
